import { Component, ChangeDetectorRef } from '@angular/core';
import { LoaderService } from './services/loader/loader.service';
@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent {
  title = 'my-app';
  isLoading: boolean = false;
  constructor(private loader: LoaderService, private cdr: ChangeDetectorRef) {
    this.loadingLoader();
  }
  loadingLoader(){
    this.loader.isLoading$.subscribe(isLoading => {
      //this.cdr.detectChanges();
      this.isLoading = isLoading;
    });
  }
}
